// extracted by mini-css-extract-plugin
module.exports = {"qrCode":"qrCode-R75XHcnl","closeBtn":"closeBtn-wR_ziRHy"};